module.exports = __webpack_public_path__ + "static/media/Video.b5b2e72e.png";